import { ListaPreciosVentaConfiguracion } from './ListaPreciosVentaConfiguracion';

export class CompaniaConfiguracion{

	public idCompania: string;
	public listaPrecios: ListaPreciosVentaConfiguracion[];

	constructor(){
		this.idCompania = null;
		this.listaPrecios = [];
	}

}


// WEBPACK FOOTER //
// ./src/app/models/CompaniaConfiguracion.ts